module.exports = __webpack_public_path__ + "img/motorway_11x2_z18.c91cff18.svg";